import styled from 'styled-components';

import { getFocusStateCSS } from "@utils";

export const ClassesPageRecordedClassCardDIV = styled.div`
  > span {
    display: block;
    color: var(--color--charcoal-700);
    margin-bottom: 10px;
  }

  p {
    color: var(--color--charcoal-700);
    margin: 0;
  }

  .WistiaPopover {
    background: black;
    box-shadow: none;
    border-radius: 6px;
    height: auto;
    margin-bottom: 20px;

    .gatsby-image-wrapper {
      opacity: 0.8;
    }

    .WistiaPopover--PlayButton {
      width: 75px;
      height: 75px;
      transition: background 0.3s;

      .Icon {
        width: 20px;
        height: 20px;
        transition: background 0.3s;
      }
    }

    &:focus-visible {
      ${getFocusStateCSS(true)}
    }
  }
`;
